import { brainGame, brainGameEntry } from "../../system/types/brainGame/brainGame";
import { language } from "../../system/types/project/language";

export enum BRAIN_GAME_ACTIONS {
    setGameData = 'SET_BRAIN_GAME_DATA',
    setActiveEntry = 'SET_BRAIN_GAME_ACTIVE_ENTRY',
    removeActiveEntry = 'REMOVE_BRAIN_GAME_ACTIVE_ENTRY',
    setActiveLanguage = 'SET_BRAIN_GAME_ACTIVE_LANGUAGE',
};

export type BrainGameState = {
    gameData?: brainGame;
    activeEntry?: brainGameEntry;
    activeLanguage?: language;
};
